import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
  onBeforeMount,
} from "@vue/composition-api";

export default function useQuizItem(props) {
  const vm = getCurrentInstance().proxy;

  const toggleActive = () => {
    if (props.formQuestion.image.url) {
      showUploadImage.isShow = true;
    }
    vm.$emit("set-active", props.formQuestion.seqQuestion);
  };

  const isHover = ref(false);

  const onHover = (hover) => {
    if (hover) isHover.value = true;
    else isHover.value = false;
  };

  const handleInput = (e) => {
    vm.$emit("input", e);
  };

  const showUploadImage = reactive({
    isShow: false,
  });

  const onShowUploadImage = () => {
    showUploadImage.isShow = true;
    vm.$emit("onShowUploadImage", showUploadImage.isShow);
  };

  const onUploadImage = (image, element) => {
    vm.$emit("onUploadImage", image, props.formQuestion);
  };

  const onAddChoice = () => {
    vm.$emit("onAddChoice", props.formQuestion);
  };

  const onUploadImageChoice = (image, element) => {
    const idx = props.formQuestion.dataChoice.indexOf(element);
    vm.$emit("onUploadImageChoice", image, props.formQuestion.dataChoice[idx]);
  };

  const onRemoveChoice = (element) => {
    const index = props.formQuestion.dataChoice.indexOf(element);
    vm.$emit("onRemoveChoice", index, props.formQuestion.dataChoice);

    if (
      props.formQuestion.dataChoice.findIndex(
        (item) => item.isCorrect === true
      ) == -1
    )
      setCorrect(0);
  };

  const onRemoveQuestion = () => {
    vm.$emit("onRemoveQuestion", props.formQuestion);
  };
  const activeQuestion = ref(false);
  const activeDesc = ref(false);

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: "#my-toolbar",
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: /•\\s\\d\\.\\s[A-z]/,
          },
        },
      },
    },
  };

  const nameNoHtml = computed(() =>
    props.formQuestion.name.replace(/<[^>]*>/g, "")
  );

  const descNoHtml = computed(() =>
    props.formQuestion.desc
      ? props.formQuestion.desc.replace(/<[^>]*>/g, "")
      : ""
  );

  const activeHover = {
    QUIZ_NAME: 1,
    QUIZ_DESC: 2,
  };

  const toggledInputFocus = (type) => {
    switch (type) {
      case activeHover.QUIZ_NAME:
        activeQuestion.value = true;
        activeDesc.value = false;
        break;
      case activeHover.QUIZ_DESC:
        activeQuestion.value = false;
        activeDesc.value = true;
        break;
      default:
        activeQuestion.value = false;
        activeDesc.value = false;
    }
  };

  const editorName = computed(() => vm.$refs.quizNameQuill.quill);
  const editorDesc = computed(() => vm.$refs.quizDescQuill.quill);

  const onFocusInput = (editor) => {
    if (editor == "quizNameQuill") {
      editorName.value.focus();
    } else if (editor == "quizDescQuill") {
      editorDesc.value.focus();
    }
  };

  const setCorrect = (element) => {
    const idx = props.formQuestion.dataChoice.indexOf(element);
    props.formQuestion.dataChoice.forEach((item, index) => {
      if (index === idx || index === element) item.isCorrect = true;
      else item.isCorrect = false;
    });
  };

  const onDuplicate = (element) => {
    vm.$emit("onDuplicate", element);
  };

  const onChange = (formDataChoice) => {
    onReorderChoice(formDataChoice);
  };

  const onReorderChoice = (formDataChoice) => {
    formDataChoice.forEach((o, index) => {
      o.seqChoice = index + 1;
    });
  };

  const onChangeFormat = () => {
    props.formQuestion.dataChoice = [
      {
        choiceId: 0,
        choiceName: "Choice",
        reason: "",
        isCorrect: true,
        imageChoice: { file: null, url: null },
      },
    ];
  };

  return {
    toggleActive,
    handleInput,
    onShowUploadImage,
    showUploadImage,
    onUploadImage,
    onAddChoice,
    onUploadImageChoice,
    onRemoveChoice,
    onRemoveQuestion,
    customQuillOption,
    activeQuestion,
    activeDesc,
    toggledInputFocus,
    onFocusInput,
    setCorrect,
    onDuplicate,
    onChange,
    activeHover,
    nameNoHtml,
    descNoHtml,
    onChangeFormat,
    onHover,
    isHover,
  };
}
